import axiosInstance from '@/utils/api.js'

var state = {
  contractType: []
}

var getters = {
  CONTRACT_TYPE: (state) => {
    return state.contractType
  }
}

var mutations = {
  SET_CONTRACT_TYPE: (state, payload) => {
    state.contractType = payload
  }
}

var actions = {
  GET_CONTRACT_TYPE: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/contract_types')
    if (result.status === 200) {
      context.commit('SET_CONTRACT_TYPE', result.data)
    }
  },
  CREATE_CONTRACT_TYPE: (context, payload) => {
    return axiosInstance.post('/tariffing/contract_type', payload)
  },
  UPDATE_CONTRACT_TYPE: (context, payload) => {
    return axiosInstance.put('/tariffing/contract_type', payload)
  },
  DELETE_CONTRACT_TYPE: (context, payload) => {
    return axiosInstance.delete('/tariffing/contract_type?contract_type_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/contractType.js